<template>
   <span class="lg:pl-2">

     <a @click="isOpen = !isOpen" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-pink-500 group-hover:text-pink-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
     </a>

<!--     <a class="text-pink hover:text-gray-700" href="#" @click="isOpen = !isOpen">{{ depositToEdit.id }}</a>-->

    <transition
        enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-in duration-200 transform"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >
<!--      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto">-->
      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto px-5 py-5">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all lg:my-8 lg:align-middle lg:max-w-4xl lg:w-full lg:p-6">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Update Deposit #{{depositToEdit.id}}
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">

                <p class=" px-2">
                  Campaign: <span class="font-bold">{{depositToEdit.campaign_name}}</span>
                </p>

                <campaign-search-input :show-only-top-level-campaigns="false" />

                <div class="my-2 w-full sm:w-1/4  flex inline space-x-3">
                  <div class="flex items-center">
                    <input id="option_check" v-model="editForm.payment_type_id" value="2" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
                    <label for="option_check" class="ml-3 block text-sm font-medium text-gray-700">
                      Check
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input id="option_cash" v-model="editForm.payment_type_id" value="3" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
                    <label for="option_cash" class="ml-3 block text-sm font-medium text-gray-700">
                      Cash
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input id="option_ach" v-model="editForm.payment_type_id" value="4" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
                    <label for="option_ach" class="ml-3 block text-sm font-medium text-gray-700">
                      ACH
                    </label>
                  </div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">
                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.check_number"  id="checkNumber" class="w-full block mx-auto sm:text-sm" placeholder="Check #">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <div class="max-w-lg flex shadow-sm">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                $
              </span>
                    <input type="text" v-model="editForm.amount" id="amount" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300" placeholder="Amount">
                  </div>
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.first_name"  id="firstName" class="w-full block mx-auto sm:text-sm" placeholder="First Name">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.last_name"  id="lastName" class="w-full block mx-auto sm:text-sm" placeholder="Last Name">
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">
                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.email"  id="emailAddress" class="w-full block mx-auto sm:text-sm" placeholder="Email">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.business_name" id="businessName" class="w-full block mx-auto sm:text-sm" placeholder="Business Name">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.address"  id="addressOne" class="w-full block mx-auto sm:text-sm" placeholder="Address">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.address2" id="addressTwo" class="w-full block mx-auto sm:text-sm" placeholder="Address Line Two">
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">
                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.city" id="city" class="w-full block mx-auto sm:text-sm" placeholder="City">
                </div>

<!--                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">-->
<!--                  <input type="text"  v-model="editForm.state" id="state" class="w-full block mx-auto sm:text-sm" placeholder="State">-->
<!--                </div>-->

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <select  v-model="editForm.state" class="w-full block mx-auto sm:text-sm">
          <option value="0">Select State</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <input type="text" v-model="editForm.zip"  id="zipCode" class="w-full block mx-auto sm:text-sm" placeholder="ZIP">
                </div>

                <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
                  <div class="relative flex items-start">
                    <div class="flex items-center h-5">
                      <input id="comments" name="comments" type="checkbox"  v-model="editForm.is_anonymous" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="comments" class="font-medium text-gray-700">Is Anonymous</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 overflow-hidden">
                <div class="my-2 px-2 w-full sm:w-1/2 overflow-hidden space-x-3">
<!--                  <button  @click="saveDeposit" type="button" class="mx-auto inline text-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-offset-2 focus:ring-green-500">{{saveTextCurrent}}</button>-->

<!--                  <button @click="resetForm" type="button" class="mx-auto inline text-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-black bg-gray-100 hover:bg-gray-200 focus:outline-none  focus:ring-offset-2 focus:ring-gray-200">Reset</button>-->
                </div>

                <div class="my-2 px-2 w-full sm:w-1/2 overflow-hidden space-x-3">
                  <input type="text" v-model="editForm.dedication" id="dedication" class="w-full block mx-auto sm:text-sm" placeholder="Dedication">
                </div>
              </div>





            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="updateDeposit" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
              Update Deposit #{{depositToEdit.id}}
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>


        </div>
      </div>
      </div>

    </transition>
   </span>
</template>

<script>

import moment from "moment";

export default {
  name: 'DepositIdLink',
  props: {
    depositToEdit: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.updateDepositForm();

    this.emitter.on('search-selected-campaign', selectedCampaignFromSearch => {
      this.editForm.campaign_id = selectedCampaignFromSearch.id
    });
  },
  data() {
    return {
      isOpen: false,
      editForm: {
        campaign_id: null,
        amount: null,
        check_number: null,
        payment_type_id: 2,
        first_name: null,
        last_name: null,
        business_name: null,
        email: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        dedication: null,
        is_anonymous: 0,
        deposit_id: this.depositToEdit.deposit_id,
        check_deposit_id: null,
      },
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },
    updateDepositForm() {

      this.updateText = 'Update Deposit# '+this.depositToEdit.id
      this.isUpdating = true

      this.editForm.first_name = this.depositToEdit.first_name;
      this.editForm.last_name = this.depositToEdit.last_name;
      this.editForm.amount = this.depositToEdit.amount;
      this.editForm.check_number = this.depositToEdit.check_number;
      this.editForm.business_name = this.depositToEdit.business_name;
      this.editForm.email = this.depositToEdit.email;
      this.editForm.address = this.depositToEdit.address;
      this.editForm.address2 = this.depositToEdit.address2;
      this.editForm.city = this.depositToEdit.city;
      this.editForm.state = this.depositToEdit.state;
      this.editForm.zip = this.depositToEdit.zip;
      this.editForm.dedication = this.depositToEdit.dedication;
      this.editForm.is_anonymous = this.depositToEdit.is_anonymous;
      this.editForm.payment_type_id = this.depositToEdit.payment_type_id;
      this.editForm.check_deposit_id = this.depositToEdit.id;
      this.editForm.campaign_id =  this.depositToEdit.campaign_id;
      this.editForm.name =  this.depositToEdit.name;
    },
    updateDeposit() {
      if (!this.editForm.campaign_id) {
        this.$notify({
          text: 'Campaign is required',
          type: 'error',
        })
        return
      }
      if (!this.editForm.first_name && !this.editForm.last_name && !this.editForm.business_name) {
        this.$notify({
          text: 'Either first name or last name or business name is required',
          type: 'error',
        })
        return
      }
      if (!this.editForm.amount) {
        this.$notify({
          text: 'Amount is required',
          type: 'error',
        })
        return
      }

      this.updateText = 'Updating Deposit#'+this.editForm.check_deposit_id+'...'

      axios.post('/create-check-deposit', this.editForm)
          .then(response => {
            this.$notify({text: 'Deposit# '+this.editForm.check_deposit_id+' updated',type: 'success', })

            this.check_deposits = response.data
            this.isOpen = false

            this.emitter.emit('check-deposit-updated')

          })
    },
  },

}
</script>
